import { Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { catchError, map, share } from 'rxjs/operators';

import { ConfigService, SentryLogger } from '@fcom/core/services';
import { FinnairAirCalendarChangeListResponse, FinnairCalendarChangeRequest } from '@fcom/dapi/api/models';
import { retryWithBackoff } from '@fcom/rx';
import { LanguageService } from '@fcom/ui-translate';
import { mapErrorForSentry } from '@fcom/core';
import { OffersChangesService } from '@fcom/dapi/api/services';

@Injectable()
export class OffersService {
  static NUMBER_OF_RETRIES = 1;

  constructor(
    private configService: ConfigService,
    private offersChangesService: OffersChangesService,
    private sentryLogger: SentryLogger,
    private languageService: LanguageService
  ) {}

  findAirCalendarChange(
    orderId: string,
    hash: string,
    body: FinnairCalendarChangeRequest
  ): Observable<FinnairAirCalendarChangeListResponse> {
    const locale = this.languageService.localeValue;
    return this.offersChangesService
      .findAirCalendarChange$Response(this.configService.cfg.offersUrl, { orderId, hash, locale, body })
      .pipe(
        retryWithBackoff(OffersService.NUMBER_OF_RETRIES),
        catchError((err: unknown) => {
          this.sentryLogger.error('Error finding air calendar change offers', {
            error: mapErrorForSentry(err),
          });
          return throwError(() => err);
        }),
        share(),
        map((r: HttpResponse<any>) => r.body as FinnairAirCalendarChangeListResponse)
      );
  }
}
